<template>
  <div id="app">
    <router-view></router-view>
  </div>
</template>

<script>

export default {
  name: 'app',
  components: {
		
  }
}
</script>

<style>
html, body {
	min-width: 1000px;
	margin: 0;
	padding: 0;
	/* overflow-x: hidden; */
	font-family: Montserrat Alternates;
}
#app {
  min-width: 1000px;
}
</style>
